const AbstractRepository = require('@/lib/Repositories/AbstractRepository');
const ApiResponseUnmapper = require('@/libraries/DigiTickets/Api/ApiResponseUnmapper');
const DataStoreNames = require('@/lib/DataStores/DataStoreNames');
const Offer = require('@/lib/Offers/Offer');
const { createModelBasicHydrator } = require('@/lib/Hydration/basicHydrator');
const { sortByNavOrder } = require('@/functions/arraySorting');

class OfferRepository extends AbstractRepository {
    /**
     * @param {ApiClient} apiClient
     * @param {ApiRequestParams} apiRequestParams
     * @param {DataStore} dataStore
     * @param {Hydrator} hydrator
     * @param {SyncStateManager} syncStateManager
     */
    constructor(
        apiClient,
        apiRequestParams,
        dataStore,
        hydrator,
        syncStateManager,
    ) {
        super(
            dataStore,
            hydrator,
            syncStateManager
        );

        this.apiClient = apiClient;
        this.apiRequestParams = apiRequestParams;
    }

    /**
     * @protected
     */
    getEntityName() {
        return 'Offer';
    }

    /**
     * @protected
     */
    getEntityClass() {
        return Offer;
    }

    /**
     * @protected
     */
    getTableName() {
        return DataStoreNames.OFFERS;
    }

    /**
     * @return {Promise<Offer[]>}
     */
    findAllManualLineOffers() {
        return this.dataStore
            .findWhere(this.getTableName(), 'trigger', 'manualLine')
            .then(createModelBasicHydrator(this.getEntityClass()))
            .then((offers) => {
                sortByNavOrder(offers);
                return offers;
            });
    }

    /**
     * @return {Promise<Offer[]>}
     */
    findAllManualOrderOffers() {
        return this.dataStore
            .findWhere(this.getTableName(), 'trigger', 'manualOrder')
            .then(createModelBasicHydrator(this.getEntityClass()))
            .then((offers) => {
                sortByNavOrder(offers);
                return offers;
            });
    }

    /**
     * @return {Promise<number>}
     */
    countAllManualOrderOffers() {
        return this.dataStore
            .getStore(this.getTableName())
            .where({ trigger: 'manualOrder' })
            .count();
    }

    /**
     * @return {Promise<number>}
     */
    countAllCouponOrderOffers() {
        return this.dataStore
            .getStore(this.getTableName())
            .where({ trigger: 'coupon' })
            .count();
    }

    /**
     * @return {Promise<Offer[]>}
     */
    findAllActive() {
        return super._findAllActive();
    }

    loadFromApi(branchID = null) {
        return this.apiClient
            .request(
                'GET',
                'offers',
                {
                    branchID, // Send the requested branchID to the API so it is used instead of any default.
                    ...this.apiRequestParams.defaultMappers(),
                }
            )
            .then((response) => ApiResponseUnmapper.transformApiResponse(response.data, 'Offer'))
            .then((data) => {
                return this.hydrator.hydrateArray(
                    data,
                    () => new (this.getEntityClass())()
                );
            });
    }
}

module.exports = OfferRepository;
